import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import ButtonGroup from "@mui/material/ButtonGroup";
import {
  Card,
  CardContent,
  Typography,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";
import AddScenarioContainerDialog from "../components/utilities/AddScenarioContainerDialog";
import { deleteContainer } from "../api/stationsApi";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import IconButton from "@mui/material/IconButton";
import { useSelector } from "react-redux";

export default function ScenarioList({ setSelectedScenario }) {
  const navigate = useNavigate();
  const [myScenarios, setMyScenarios] = useState([]);
  const [allScenarios, setAllScenarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("my");

  // const token =
  //   "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MzQ3LCJpYXQiOjE3Njk2ODEzNzAsImV4cCI6MTc2OTY4MjI3MH0.j6i2WPdDtaiUkmA__Trvm9smU0RNJI7OCDUdaveEw0k";

  const { user } = useSelector((state) => state.auth);

  const token = user.jwt;

  const fetchScenarios = async () => {
    try {
      setLoading(true);

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      const [myRes, allRes] = await Promise.all([
        fetch(
          `${process.env.REACT_APP_API_URL_VR_EDITOR}/scenario-builder/containers`,
          {
            headers,
          },
        ),
        fetch(
          `${process.env.REACT_APP_API_URL_VR_EDITOR}/scenario-builder/all-containers`,
          {
            headers,
          },
        ),
      ]);

      const [myData, allData] = await Promise.all([
        myRes.json(),
        allRes.json(),
      ]);

      setMyScenarios(myData);
      setAllScenarios(allData);
    } catch (err) {
      console.error("Error fetching scenarios:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchScenarios();
  }, []);

  const openScenario = (scenario) => {
    setSelectedScenario(scenario);
    // navigate(`/scenario/${scenario.id}`);
    navigate(`/vr/scenarios/${scenario.id}`);
  };

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="50vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  const renderScenarios = (scenarios) => {
    console.log("scenarios", scenarios);
    if (scenarios.length === 0) {
      return <Typography color="textSecondary">Brak scenariuszy</Typography>;
    }

    const deleteScenario = async (id) => {
      await deleteContainer(id);
      fetchScenarios();
    };

    return (
      <Box
        sx={{
          maxHeight: "70vh",
          overflowY: "auto",
          pr: 1,
        }}
      >
        <Grid container spacing={2}>
          {scenarios?.map((s) => (
            <Grid item xs={12} key={s.id}>
              <Card variant="outlined" sx={{ position: "relative" }}>
                {activeTab === "my" && (
                  <IconButton
                    size="small"
                    onClick={() => deleteScenario(s.id)}
                    sx={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                      color: "error.main",
                      "&:hover": {
                        backgroundColor: "error.light",
                        color: "#fff",
                      },
                    }}
                  >
                    <DeleteOutlineIcon fontSize="small" />
                  </IconButton>
                )}

                <CardContent>
                  <Typography variant="h6">{s.name}</Typography>

                  <Typography color="textSecondary" sx={{ mb: 2 }}>
                    ID: {s.id} | Limit: {s.limit ?? "Brak"}
                  </Typography>

                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => openScenario(s)}
                  >
                    Otwórz
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  };

  return (
    <Box sx={{ maxWidth: "800px", margin: "0 auto", p: 2 }}>
      <Box mb={3} textAlign="center">
        <ButtonGroup variant="contained" aria-label="Basic button group">
          <Button
            onClick={() => setActiveTab("my")}
            color={activeTab === "my" ? "primary" : "inherit"}
          >
            Moje scenariusze
          </Button>
          <Button
            onClick={() => setActiveTab("all")}
            color={activeTab === "all" ? "primary" : "inherit"}
          >
            Wszystkie scenariusze
          </Button>
        </ButtonGroup>
      </Box>

      {activeTab === "my" && (
        <>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              mt: 5,
              mb: 5,
              verticalAlign: "middle",
            }}
          >
            <Typography variant="h5">Moje scenariusze</Typography>

            <AddScenarioContainerDialog
              token={token}
              onSuccess={fetchScenarios}
            />
          </Box>
          {renderScenarios(myScenarios)}
        </>
      )}

      {activeTab === "all" && (
        <>
          <Typography variant="h5" gutterBottom>
            Wszystkie scenariusze
          </Typography>
          {renderScenarios(allScenarios)}
        </>
      )}

      {activeTab === "other" && (
        <>
          <Typography variant="h5" gutterBottom>
            Inne scenariusze
          </Typography>
          <Typography color="textSecondary">
            Brak scenariuszy do wyświetlenia
          </Typography>
        </>
      )}
    </Box>
  );
}
